// extracted by mini-css-extract-plugin
export default {"container":"FilteringAndSorting_container__5KEKe","wrapper":"FilteringAndSorting_wrapper__zj8in"};